import React from 'react';
import {
  Box,
  Dropdown,
  DropdownOverlay,
  SelectInput,
  ActionList,
  ActionListItem,
} from '@razorpay/blade/components';
import { PFWageCalculationType } from 'api/employeeOnboarding';
import { RegisterGenericType } from 'forms/useRegister';

// The statutory PF wage ceiling is ₹25,000 (EPFO notification), so that is what this option
// offers to cap at — unconditionally, for every org.
//
// It is deliberately NOT driven by the org's feature flags. This is a persistent employee
// setting meaning "cap at the statutory limit", not a statement about one wage month:
// use15kPfLimit pins September 2026 only and cannot hold an org past that month, so letting it
// relabel the option would put a transitional, single-month figure on a permanent setting.
//
// Only the label is ₹25,000. The stored value stays '15k' — the existing enum for "cap at the
// statutory limit", not a reference to an amount.
const pfWageCalculationTypes: Array<{
  title: string;
  value: PFWageCalculationType;
}> = [
  {
    title: 'Use Company Default',
    value: 'default',
  },
  {
    title: 'Use ₹25,000 Limit',
    value: '15k',
  },
  {
    title: 'No Limit',
    value: 'no_limit',
  },
];

export const PFWageCalculationSelectInput = ({
  registerFormData,
}: {
  registerFormData: RegisterGenericType<{ pfWagesCalculationType: PFWageCalculationType[] }>;
}) => {
  return (
    <Box>
      <Dropdown selectionType="single">
        <SelectInput
          label="PF Wage Calculation"
          labelPosition="top"
          {...registerFormData('pfWagesCalculationType', 'select')}
          isRequired
          necessityIndicator="required"
        />
        <DropdownOverlay>
          <ActionList>
            {pfWageCalculationTypes.map((type) => (
              <ActionListItem key={type.value} title={type.title} value={type.value} />
            ))}
          </ActionList>
        </DropdownOverlay>
      </Dropdown>
    </Box>
  );
};
